<template>
  <div id="EnterpriseInformation">
    <h2 id="title" >企业基本信息</h2>
    <div id="btm">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100rem"
        class="demo-ruleForm"
      >
        <p class="head">企业信息</p>
        <div id="mid">
          <div class="mid-left">
            <div class="NestingBoxes1">
              <p class="Openterprise">企业名称</p>
              <el-form-item prop="name">
                <el-input
                  placeholder="请输入企业全称"
                  v-model="ruleForm.name"
                ></el-input>
              </el-form-item>
            </div>
            <div class="NestingBoxes1">
              <p class="Openterprise">企业账号</p>
              <div id="username">
                <p>{{ $store.state.homeitem.user.tel }}</p>

                <Dialog></Dialog>
              </div>
            </div>
            <div class="NestingBoxes">
              <p class="Openterprise">企业邮箱</p>
              <el-form-item prop="elim">
                <el-input
                  placeholder="请输入企业邮箱"
                  v-model="ruleForm.elim"
                ></el-input>
              </el-form-item>
            </div>
            <div class="NestingBoxes">
              <p class="Openterprise">企业地址</p>
              <el-form-item prop="site">
                <el-input
                  placeholder="请输入企业地址"
                  v-model="ruleForm.site"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="kong"></div>
          <div class="mid-right">
            <p>企业logo</p>

            <el-upload
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :before-upload="upData"
            >
              <div class="Png-logo">
                <div id="logo">
                  <img v-if="imageUrl !== ''" :src="imageUrl" class="avatar" />
                  <img v-else :src="EnterpriseLogo" alt="" />
                </div>
                <el-button size="small" class="Btn-Logo" plain
                  ><i class="el-icon-upload2"></i>上传logo</el-button
                >
              </div>
            </el-upload>

            <p class="app-list">项目预览图</p>
            <div class="pngAll">
              <div class="Qyylt">
                <el-upload
                  action=""
                  :show-file-list="false"
                  :on-success="pngclick"
                  :before-upload="pngupload"
                  ><div class="app-play">
                    <img v-if="pageclick" :src="pageclick" class="avatar" />
                    <img
                      v-else
                      class="avatar"
                      :src="EnterprisePreview"
                      alt=""
                    />
                  </div>
                  <el-button plain class="login-btn-play"
                    ><i class="el-icon-upload2"></i>上传图片</el-button
                  >
                </el-upload>
              </div>
              <div class="Jbs"></div>
            </div>
          </div>
        </div>
        <div class="funted">
          <p class="head">企业运营者信息</p>
          <div class="ebs">
            <div class="NestingBoxes2">
              <p class="Openterprise">运营者名字</p>
              <el-form-item prop="list">
                <el-input
                  placeholder="请输入运营者名字"
                  v-model="ruleForm.list"
                ></el-input>
              </el-form-item>
            </div>
            <div class="NestingBoxes2">
              <p class="Openterprise">运营者手机号</p>
              <el-form-item prop="for">
                <el-input
                  placeholder="请输入运营者手机号"
                  v-model="ruleForm.for"
                ></el-input>
              </el-form-item>
            </div>
            <div class="NestingBoxes2">
              <p class="Openterprise">运营者职务</p>
              <el-form-item prop="git">
                <el-input
                  placeholder="请输入运营者职务"
                  v-model="ruleForm.git"
                ></el-input>
              </el-form-item>
            </div>
            <el-form-item id="btn">
              <el-button
                type="primary"
                class="getUpdata"
                @click="submitForm('ruleForm')"
                >更新基本信息</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { UPLOAD_IMFIRM, UPLOAD_FILMLOGO,UPLOAD_CHANGEIMG } from "../../api/upload";
import Dialog from "./entcomponents/dialog";
import { EnterpriseBackground } from "../../api/backstageManagement";
import { play} from "../../api/login";
export default {
  name: "EnterpriseInformation",
  components: {
    Dialog,
  },
  data() {
    var email = (rule, value, callback) => {
      var t = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    //   console.log(t.test(value));
      if (value === "" || value.trim() === "") {
        callback(new Error("企业邮箱不可为空！"));
      } else if (t.test(value) !== true) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();

      
      }
    };
    return {
      EnterpriseLogo: require("../../assets/img/imgLogo.png"), //初始企业Logo
      imageUrl: "", //上传企业Logo
      pageclick: "", //上传企业图片
      EnterprisePreview: require("../../assets/img/firmImg.png"), //初始企业图片
      forsUser: [],
      rules: {
        name: [
          { required: true, message: "企业名称不可为空！", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        site: [
          { required: true, message: "企业地址不可为空！", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        elim: [{ validator: email, trigger: "blur" }],
        // list: [
        //   { required: true, message: "运营者名字不可为空！", trigger: "blur" },
        //   { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" },
        // ],
        for: [
          {
            required: true,
            message: "运营者手机号不可为空！",
            trigger: "blur",
          },
          { min: 11, max: 11, message: "长度在11个字符", trigger: "blur" },
        ],
        git: [
          { required: true, message: "运营者职务不可为空！", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      ruleForm: {
        name: "",
        elim: "",
        site: "",
        list: "",
        for: "",
        git: "",
      },
    };
  },
  created() {
    //获取企业用户初始值
    this.getUser();
  },

  methods: {
    //获取企业用户信息
    getUser() {
      EnterpriseBackground.search().then((res) => {
        // console.log(res.data.data.firm);
        this.forsUser = res.data.data.firm.fileFirmRefList;
        this.ruleForm.name = res.data.data.firm.firmName;
        this.ruleForm.elim = res.data.data.firm.firmEmail;
        this.ruleForm.site = res.data.data.firm.firmAddress;
        this.ruleForm.list = res.data.data.firm.operatorName;
        this.ruleForm.for = res.data.data.firm.operatorTel;
        this.ruleForm.git = res.data.data.firm.deptJobName;
        this.EnterpriseLogo = res.data.data.firm.firmLogo;
        this.EnterprisePreview = this.$store.state.project.projectInfo.projectImg
        // this.EnterprisePreview = res.data.data.firm.imgList[0].uploadFileUrl;
      });
      play.currentProjectInfo().then((res) => {
         this.pageclick =  res.data.data.project.projectImg
        })
    },
    //logo
    upData(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      UPLOAD_FILMLOGO(
        file,
        this.$store.state.project.projectInfo.projectId
      ).then((res) => {
        // console.log(res);
        if (res.data.status) {
          this.imageUrl = URL.createObjectURL(file);
        }
      });
      return false;
    },

    //企业图
    pngclick(res, file) {
      this.pageclick = URL.createObjectURL(file.raw);
    //   console.log(this.pageclick);
    },
    pngupload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
    //   console.log(this.forsUser);
      this.forsUser.map((item, index) => {
        if (index == 0) {
        //   console.log(item);
        EnterpriseBackground.userPngDetele(item.refId).then((array) => {
          // EnterpriseBackground.userPngDetele(item.refId).then((array) => {
            // console.log(array);
            UPLOAD_CHANGEIMG(
              file,
              this.$store.state.project.projectInfo.firmId
            ).then((res) => {
              //   console.log(file);
            //   console.log(res.data);
              //this.pageclick = res.data.data.path;
              this.pageclick = URL.createObjectURL(file);
            });
          });
        }
      });

      return false;
    },

    submitForm(formName) {
    //   console.log(
    //     1,
    //     this.$store.state.homeitem.user.firmId,
    //     this.ruleForm.name,
    //     this.ruleForm.elim,
    //     this.ruleForm.site,
    //     this.ruleForm.list,
    //     this.ruleForm.git,
    //     this.ruleForm.for,
    //     "我是企业描述"
    //   );
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //  console.log(this.pageclick)//企业预览图)
          // this.imageUrl, //上传企业Logo
          // this.pageclick
       
          EnterpriseBackground.firmUpdate(
            this.$store.state.homeitem.user.firmId,
            this.ruleForm.name,
            this.ruleForm.elim,
            this.ruleForm.site,
            this.ruleForm.list,
            this.ruleForm.git,
            this.ruleForm.for,
            "我是企业描述"
          ).then((res) => {
            if (res.data.status) {
              this.$message({
                message: "企业基本信息更新成功",
                type: "success",
              });
              
                this.getUser();
            } else {
              this.$message.error("企业信息输入有误,请重试！");
            }
          });
        } else {
        //   console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
#EnterpriseInformation {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0rem 0rem 16rem 0rem rgba(0, 43, 102, 0.04);

  .NestingBoxes {
    height: 97rem;
    margin-top: 5rem;
  }
  .NestingBoxes1 {
    margin-bottom: 20rem;
    .Openterprise {
      color: #666666;
      margin-bottom: 5rem
    }
  }
  .NestingBoxes2 {
    height: 90rem;
    margin-top: 15rem;
  }
  .kong {
    width: 72rem;
    height: 100%;
  }
  #title {
    width: 100%;
    height: 8%;
    padding: 23rem 0 0 24rem;
    font-size: 24rem;
    color: #333333;
    border-bottom: 1rem solid #e4e1e1;
  }
  #btm {
    width: 100%;
    height: 93%;
    overflow: hidden;
    z-index: inherit;
    padding: 36rem 24rem 9rem 24rem;

    .head {
      font-size: 16rem;
      font-weight: bold;
      color: #333333;
      border-bottom: 1rem rgba(0, 0, 0, 0.15) solid;
      margin-bottom: 10px;
   
    }

    #mid {
      display: flex;
      height: 43%;
      // justify-content: space-between;
      .mid-left {
        // height:450rem;
        .w(440);

        #username {
          height: 15rem;
          font-size: 16rem;
          display: flex;
          width: 180rem;
          justify-content: space-between;
          color: #666666;
          .el-button {
            padding-top: 0 !important;
          }
        }
      }
      .mid-right {
        // margin-left: 72rem;
        // height: 470rem;
        .Png-logo {
          width: 102rem;
        }
        #logo {
          .w(48);
          .h(48);
          margin-bottom: 12px;
          img {
            .w(48);
            .h(48);
          }
        }
        p {
          margin-bottom: 3rem;
          font-size: 16rem;
          color: #666666;
        }

        .Btn-Logo {
          .w(102);
          .h(37);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17rem;
          font-family: "SourceHanSansCN-EXTRALIGHT";
          font-weight: 400;
          padding: 0;
        }

        .Btn-Logo:focus,
        .Btn-Logo:hover {
          border-color: #36abff;
          color: #36abff;
        }

        .login-btn-play {
          .w(102);
          .h(37);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17rem;
          font-family: "SourceHanSansCN-EXTRALIGHT";
          font-weight: 400;
          padding: 0;
        }

        .Qyylt {
          width: 375rem;
          height: 164rem;
          float: left;
        }
        .Jbs {
          width: 577rem;
          height: 164rem;
          float: left;
          background: linear-gradient(
            90deg,
            rgba(13, 148, 255, 0.2) 0%,
            rgba(13, 148, 255, 0) 100%
          );
          margin-top: 10rem;
        }
        .app-list {
          margin-top: 20rem;
        }
        .app-play {
          width: 375rem;
          height: 164rem;
          // background-color: red;
          margin-bottom: 12rem;
          margin-top: 10rem;
          img {
            width: 375rem;
            height: 164rem;
          }
        }
      }
    }
    //   	.getUpdata .is-active,
    // .getUpdata:active {
    //   background: #0070d9;
    //   border-color: #0070d9;
    //   color: #fff;
    // }

    .getUpdata:focus,
    .getUpdata:hover {
      background: #36abff;
      border-color: #36abff;
      color: #fff;
    }

    .getUpdata {
      color: #fff;
      background-color: #0d94ff;
      border-color: #0d94ff;
    }
    .funted {
      height: auto !important;
      margin-top: 50rem;
      height: 45%;
      //   display: grid;
    }
  }
}
</style>
